<template>
  <!-- 大盒子 -->
  <div class="MedicenCata">
    <!-- 主体内容 -->
    <div class="main">
      <!-- left -->
      <!-- right -->
      <div class="main-right" ref="mainRight">
        <div class="main-icon"
             style="display: flex; align-items: center; padding: 8px 10px; background: #fff; border-bottom: 1px solid #ebeef5;">
          <!-- 左侧图标和标题 -->
          <div class="main-icon-a" style="display: flex; align-items: center; margin-right: 15px;">
            <i :class="iconComes"
               style="border-radius: 50%; font-size: 20px; padding: 6px; background-color: #5a5a5a; color: #fff;"></i>
            <span style="font-size: 12px; font-weight: bold; margin-left: 8px; color: #606266;">{{
                CatalogueName
              }}</span>
          </div>

          <!-- 中间区域（所有筛选条件和按钮都在一行） -->
          <div style="display: flex; align-items: center; flex-wrap: nowrap;">
            <!-- 状态下拉 -->
            <div class="main-icon-b" style="margin-right: 20px;">
              <span style="font-size: 12px; color: #606266; font-weight: bold;">状态:</span>
              <el-dropdown @command="handleCommand" trigger="click" style="margin-left: 4px;">
    <span class="el-dropdown-link" style="font-size: 12px;color: #606266;font-weight: bold;">
      {{ DropDownedName }}<i class="el-icon-down"></i>
    </span>
                <el-dropdown-menu slot="dropdown" class="status-dropdown">
                  <el-dropdown-item command="d" dropdown>全部</el-dropdown-item>
                  <el-dropdown-item command="c">未作废</el-dropdown-item>
                  <el-dropdown-item command="a">已作废原单</el-dropdown-item>
                  <el-dropdown-item command="b">作废负单</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>

            <!-- 搜索框 -->
            <div style="display: flex; align-items: center; margin-right: 20px; white-space: nowrap;">
              <span style="font-size: 12px; color: #606266; font-weight: bold; margin-right: 8px;">关键字:</span>
              <el-input v-model="queryConditionForm.name" size="mini" style="width: 180px;"
                        @keyup.enter.native="loadData"></el-input>
            </div>

            <div class="block">
              <el-date-picker
                  size="mini"
                  v-model="queryConditionForm.timeFrameArr"
                  type="datetimerange"
                  align="right"
                  unlink-panels
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  @change="handleConditionQuery"
                  :picker-options="pickerOptions">
              </el-date-picker>
            </div>

            <!-- 按钮组（直接跟在时间选择器后面） -->
            <div style="display: flex; align-items: center;">
              <el-button
                  v-for="(v,i) in headerBtn"
                  :key="i"
                  :type="v.type"
                  :loading="loading"
                  :icon="v.icon"
                  size="mini"
                  :style="{...v.style, 'margin-left': '6px'}"
                  @click="handClick(i)">
                {{ v.title }}
              </el-button>
            </div>
          </div>
        </div>
        <!-- table -->
        <div class="table">
          <el-table :data="tableData"
                    border
                    :summary-method="getSummaries"
                    @row-dblclick="handleDbShowData"
                    show-summary>
            <el-table-column v-for="(col, inx) in tableRows" :key="inx" :type="col.type" :prop="col.prop"
                             :label="col.name" :render-header="labelHead"
                             :min-width="getColumnWidth(col.label,col.prop,tableData)">
              <template #default="{ row }">
                {{ safeGetMappedValue(col, row) }}
              </template>
            </el-table-column>
            <el-table-column fixed="left" label="行号" type="index"></el-table-column>
            <el-table-column fixed="right" label="操作" width="150">
              <template slot-scope="scope">
                <div class="editbox" style="text-align: center;">
<!--                  <el-button type="primary" @click="editReservation(scope.row)" size="mini"
                             :disabled="scope.row.visitState!==2"
                             v-if="$store.getters.hasPermission('system:register:edit')"
                  >
                    修改
                  </el-button>-->
                  <el-button type="warning" :disabled="scope.row.regState !== 0" @click="handleRefundClick(scope.row)"
                             v-if="$store.getters.hasPermission('system:register:refund')"
                             size="mini">
                    {{ scope.row.loading ? '处理中...' : '退款' }}
                  </el-button>
                  <!--                  <el-button
                                        type="danger"
                                        :disabled="scope.row.regState !== 0 || scope.row.visitState === 6"
                                        @click="registrationCancellation(scope.row)"
                                        size="mini"
                                    >
                                      {{ scope.row.loading ? '处理中...' : '作废' }}
                                    </el-button>-->
                </div>
              </template>

            </el-table-column>
          </el-table>
        </div>

        <div class="dialog">
          <el-dialog title="挂号详情"
                     :close-on-click-modal="false" :visible.sync="showModalVisible" class="showDialog" width="50%">
            <div class="aform">
              <!-- 表单 -->
              <el-form :model="showForm" label-width="90px" size="mini" disabled="disabled">
                <el-row :gutter="4">
                  <el-col :span="v.spanRows" type="flex" v-for="(v,i) in showType" :key="i">
                    <!-- input -->
                    <el-form-item v-if="v.type === 'input'" :label="v.label" style="white-space: nowrap">
                      <el-input :suffix-icon='v.prefix' v-model="$data.showForm[v.modelValue]">
                      </el-input>
                    </el-form-item>

                    <el-form-item v-if="v.type === 'select'" :label="v.label" style="white-space: nowrap">
                      <el-select v-model="$data.showForm[v.modelValue]" filterable
                                 :placeholder="$data.showForm[v.modelValue] ? '' : ' '">
                        <el-option v-for="item in $data[v.op]" :key="item.id" :label="item.label" :value="item.id">
                          <span style="float: center; color: #8492a6; font-size: 12px">{{ item.label }}</span>
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-row>
                <!-- 将按钮放在el-form内部，使用el-form-item控制位置 -->
                <el-form-item style="text-align: right; margin-top: 20px; margin-bottom: 0">
                  <el-button :disabled="false" type="warning" size="mini" @click="handleCancelShow">取消</el-button>
                </el-form-item>
              </el-form>
            </div>

          </el-dialog>

          <el-dialog
              title="请选择医保退款方式"
              :visible.sync="showRefundMethodDialog"
              width="400px"
          >
            <div style="text-align: center;">
              <el-radio-group v-model="selectedRefundMethod">
                <el-radio label="03">刷卡</el-radio>
                <el-radio label="01">电子凭证</el-radio>
              </el-radio-group>
            </div>
            <div slot="footer" class="dialog-footer">
              <el-button @click="showRefundMethodDialog = false">取消</el-button>
              <el-button type="primary" @click="handleRefundMethodConfirm">确定</el-button>
            </div>
          </el-dialog>
          <div/>

          <el-dialog title="修改挂号信息"
                     :visible.sync="editModalVisible"
                     class="editModalVisible"
                     width="25%">
            <div class="aform">
              <el-form :model="editForm" label-width="90px" size="mini">
                <!-- 第一行：挂号类别 -->
                <el-form-item label="挂号类别:">
                  <el-select v-model="editForm.regTypeId" style="width: 100%" disabled>
                    <el-option v-for="item in regOptions" :key="item.id" :label="item.label"
                               :value="item.id"></el-option>
                  </el-select>
                </el-form-item>

                <!-- 第二行：挂号日期和时段 -->
                <el-row :gutter="10">
                  <el-col :span="12">
                    <el-form-item label="挂号日期:">
                      <el-input v-model="editForm.regDate" disabled></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="时段:">
                      <el-select v-model="editForm.timeFrame" placeholder="请选择时段" style="width:100%"
                                 @change="getActiveList">
                        <el-option v-for="item in timeFrameOption" :key="item.id" :label="item.label" :value="item.id"
                                   :disabled="item.id < currentTimeFrame"></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-row>

                <el-row :gutter="10">
                  <el-col :span="12">
                    <el-form-item label="当前科室:">
                      <el-select v-model="editForm.currentDept" style="width:100%" @change="getActiveList" disabled>
                        <el-option v-for="item in allDeptOptions" :key="item.id" :label="item.label"
                                   :value="item.id"></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="当前医生:">
                      <el-select v-model="editForm.currentDoctor" style="width:100%" @change="getActiveList" disabled>
                        <el-option v-for="item in doctorOptions" :key="item.id" :label="item.label"
                                   :value="item.id"></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-row>


                <!-- 第三行：挂号科室 -->
                <el-form-item label="挂号科室:">
                  <el-select v-model="editForm.regDepId" placeholder="请选择科室" style="width:100%"
                             @focus="getActiveList">
                    <el-option v-for="item in deptOptions" :key="item.id" :label="item.label"
                               :value="item.id"></el-option>
                  </el-select>
                </el-form-item>

                <!-- 第四行：挂号医生 -->
                <el-form-item label="挂号医生:">
                  <el-select v-model="editForm.regDoctorId" placeholder="请选择医生" style="width:100%"
                             @focus="getActiveList2">
                    <el-option v-for="item in doctorOptions" :key="item.id" :label="item.label"
                               :value="item.id"></el-option>
                  </el-select>
                </el-form-item>
              </el-form>
            </div>

            <div slot="footer" class="dialog-footer">
              <el-button size="mini" @click="handleCancelEditReservatione">取消</el-button>
              <el-button size="mini" type="primary" @click="editRegister">确定</el-button>
            </div>
          </el-dialog>
          <!-- 退款方式选择弹窗 -->
          <el-dialog
              title="选择退款方式"
              :visible.sync="refundDialogVisible"
              width="40%"
              :close-on-click-modal="false"
              @close="resetRefundForm"
          >
            <el-form size="mini" label-width="100px">
              <el-form-item label="退款明细:">
                <div style="padding: 8px; background: #f5f7fa; border-radius: 4px;">
                  <div>患者姓名：{{ currentRefundRow?.name }}</div>
                  <div>挂号时间：{{ currentRefundRow?.regTime }}</div>
                  <div>挂号科室：{{ currentRefundRow?.regDepName || getDeptName(currentRefundRow?.regDepId) }}</div>
                  <div>挂号医生：{{ currentRefundRow?.regDoctorName || getDoctorName(currentRefundRow?.regDoctorId) }}</div>
                  <div style="margin-top: 8px; font-weight: bold;">退款金额：{{ refundTotalAmount.toFixed(2) }} 元</div>
                </div>
              </el-form-item>

              <!-- 原始支付方式展示 -->
              <el-form-item label="原支付方式:">
                <div v-for="(pay, index) in originalPayWays" :key="index" style="margin-bottom: 5px;">
                  <el-tag type="info" size="small" style="width: 100px;">{{ pay.wayName }}</el-tag>
                  <span style="margin-left: 10px;">{{ pay.amount.toFixed(2) }} 元</span>
                </div>
              </el-form-item>

              <!-- 退款方式选择 -->
              <el-form-item label="退款方式:" prop="refundWays">
                <el-checkbox-group v-model="refundForm.refundWays">
                  <el-checkbox
                      v-for="method in dynamicPaymentMethods"
                      :key="method.id"
                      :label="method.id"
                      :disabled="!canRefundByWay(method.id)">
                    <span>{{ method.wayName }}</span>
                    <span style="margin-left: 10px; color: #909399; font-size: 12px;">
            (可退: {{ getAvailableRefundAmount(method.id).toFixed(2) }} 元)
          </span>
                  </el-checkbox>
                </el-checkbox-group>
              </el-form-item>

              <!-- 退款金额分配 -->
              <template v-if="refundForm.refundWays && refundForm.refundWays.length > 0">
                <div v-for="wayId in refundForm.refundWays" :key="wayId">
                  <el-form-item :label="getWayNameById(wayId) + '金额:'">
                    <el-input-number
                        v-model="refundForm.refundAmounts[wayId]"
                        :min="0"
                        :max="getMaxRefundAmount(wayId)"
                        :precision="2"
                        :step="0.01"
                        size="small"
                        style="width: 200px;">
                    </el-input-number>
                    <span style="margin-left: 10px;">元</span>
                    <span style="margin-left: 10px; font-size: 12px; color: #909399;">
            (最多: {{ getMaxRefundAmount(wayId).toFixed(2) }})
          </span>
                  </el-form-item>
                </div>

                <el-form-item label="合计金额:">
        <span :style="{color: totalPayWayAmount !== refundTotalAmount ? '#f56c6c' : '#67c23a', fontWeight: 'bold'}">
          {{ (totalPayWayAmount || 0).toFixed(2) }} 元
        </span>
                  <span style="margin-left: 10px;">(应退: {{ (refundTotalAmount || 0).toFixed(2) }} 元)</span>
                </el-form-item>
              </template>
            </el-form>

            <span slot="footer" class="dialog-footer">
    <el-button @click="refundDialogVisible = false" size="mini">取消</el-button>
    <el-button
        type="primary"
        @click="handleConfirmRefund"
        size="mini"
        :disabled="totalPayWayAmount !== refundTotalAmount || totalPayWayAmount === 0">
      确定退款
    </el-button>
  </span>
          </el-dialog>
        </div>
        <el-pagination
            class="fixed-pagination"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="pageNum"
            :page-sizes="[8, 16, 24]"
            :page-size="pageSize"
            :total="totalSize"
            layout="total, sizes, prev, pager, next, jumper"
            background>
          >
        </el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import {
  getAllReservation,
  getDoctorList,
  getRegisterType,
  registrationRefund
} from "@/api/reservation/reservationList";
import ShowType from './reservationListType.js';
import dayjs from "dayjs";
import {
  editRegisterList,
  getActiveList
} from "@/api/reservation/reservation";
import { withLoading } from "@/untils/loading";
import { buildYbRequest, generateYbHeaders, sendYbRequest } from "@/api/yb/ybApi";
import { addYbResponseData, addYbRquestData, getqdNo } from "@/api/yb";
import { handleYB_1101_Upload, handleYB_Business_Upload } from "@/api/yb/ocxActiveXApi";
import { getPatternPaymentList } from "@/api/patternPayment/patternPayment";

// 工厂函数：生成空的编辑表单
const getEmptyEditForm = () => ({
  id: null,
  regDepId: null,
  regDoctorId: null,
  regTypeId: null,
  regDate: null,
  timeFrame: null,
  currentDoctor: null,
  currentDept: null,
});

// 工厂函数：生成空的查看表单
const getEmptyShowForm = () => ({
  createTime: '',
  discountMoney: null,
  docNo: null,
  id: null,
  name: '',
  nullifyReason: '',
  nullifyRegId: null,
  nullifyTime: '',
  nullifyUserId: null,
  optTime: '',
  orderId: null,
  patientId: null,
  payState: '',
  payType: null,
  receivableMoney: null,
  receivedMoney: null,
  regDepId: null,
  regDoctorId: null,
  regMode: null,
  regNum: null,
  regState: null,
  regTime: '',
  regTypeId: null,
  regUserId: null,
  remake: '',
  utyTimeDetailsId: null,
  visitId: null,
  visitState: null,
});

// 工厂函数：生成空的退款表单
const getEmptyRefundForm = () => ({
  id: null,
  payWay: [],
  refundWays: [],
  refundAmounts: {}
});

export default {
  data() {
    const currentHour = dayjs().hour();
    const currentTimeFrame = currentHour < 12 ? 1 : (currentHour < 18 ? 2 : 3);
    return {
      // 日期选择器快捷选项
      pickerOptions: {
        shortcuts: [
          {
            text: '最近一周',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          },
          {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          },
          {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          }
        ]
      },
      // 基础数据
      CatalogueName: '挂号列表',
      DropDownedName: '全部',
      iconComes: 'el-icon-byj',
      loading: false,
      pageNum: 1,
      pageSize: 8,
      totalSize: 10,
      regState: null,
      showModalVisible: false,
      editModalVisible: false,
      showRefundMethodDialog: false,
      refundDialogVisible: false,
      selectedRefundMethod: '01',
      currentRow: null,
      currentRefundRow: null,
      dynamicPaymentMethods: [],
      isRequesting: false,
      signNo: null,

      // 查询条件
      queryConditionForm: {
        name: '',
        timeFrameArr: [
          dayjs().startOf('day').format('YYYY-MM-DD HH:mm:ss'),
          dayjs().endOf('day').format('YYYY-MM-DD HH:mm:ss')
        ]
      },

      // 表单数据
      editForm: getEmptyEditForm(),
      showForm: getEmptyShowForm(),
      refundForm: getEmptyRefundForm(),

      // 表格数据
      tableData: [],

      // 下拉选项
      regOptions: [],
      doctorOptions: [],
      allDeptOptions: [],
      deptOptions: [],
      timeFrameOption: [
        { id: 1, label: '上午' },
        { id: 2, label: '下午' },
        { id: 3, label: '晚上' }
      ],
      visitStateOption: [
        { id: 1, label: '待签到' },
        { id: 2, label: '待就诊' },
        { id: 3, label: '已接诊' },
        { id: 4, label: '已取消' },
        { id: 5, label: '待分诊' },
        { id: 6, label: '已退款' }
      ],
      regStateOption: [
        { id: 0, label: '未作废' },
        { id: 1, label: '已作废原单' },
        { id: 2, label: '作废负单' }
      ],
      payTypeOptions: [
        { id: 1, label: '现金' }, { id: 2, label: '支付宝' }, { id: 3, label: '微信' },
        { id: 4, label: '银行卡' }, { id: 5, label: '医保' }, { id: 6, label: '优惠支付' },
        { id: 7, label: '健康卡支付' }, { id: 8, label: '聚合支付' }, { id: 9, label: '组合支付' },
        { id: 10, label: '医保组合' }
      ],
      payStateOptions: [
        { id: 0, label: '否' },
        { id: 1, label: '是' }
      ],

      // 表格列配置
      tableRows: [
        { name: "挂号单据编号", prop: "docNo" },
        { name: "姓名", prop: "name" },
        { name: "挂号时间", prop: "regTime" },
        { name: "挂号操作时间", prop: "optTime" },
        { name: "挂号科室", prop: "regDepId", op: 'deptOptions' },
        { name: "挂号医生", prop: "regDoctorId", op: 'doctorOptions' },
        { name: "挂号类型", prop: "regTypeId", op: 'regOptions' },
        { name: "挂号进度", prop: "visitState", op: 'visitStateOption' },
        { name: "挂号状态", prop: "regState", op: 'regStateOption' },
        { name: "应收金额", prop: "receivedMoney" },
        { name: "实收金额", prop: "receivableMoney" },
        { name: "支付状态", prop: "payState", op: 'payStateOptions' },
        { name: "支付方式", prop: "payWayDisplay" }
      ],

      showType: ShowType,
      userInfo: null,
    };
  },

  computed: {
    currentTimeFrame() {
      const hour = dayjs().hour();
      return hour < 12 ? 1 : (hour < 18 ? 2 : 3);
    },
    // 原始支付方式列表
    originalPayWays() {
      if (this.currentRefundRow && this.currentRefundRow.payWay) {
        return this.currentRefundRow.payWay.map(pay => {
          const method = this.dynamicPaymentMethods.find(m => m.id === pay.wayId);
          return {
            wayId: pay.wayId,
            wayName: method ? method.wayName : '未知',
            amount: pay.amount || 0,
            classId: pay.classId
          };
        });
      }
      return [];
    },
    // 应退总额
    refundTotalAmount() {
      if (this.currentRefundRow) {
        return this.currentRefundRow.receivableMoney || this.currentRefundRow.receivedMoney || 0;
      }
      return 0;
    },
    // 选择的支付方式总金额
    totalPayWayAmount() {
      let total = 0;
      if (this.refundForm.refundAmounts) {
        Object.values(this.refundForm.refundAmounts).forEach(amount => {
          total += (amount || 0);
        });
      }
      return total;
    }
  },

  async mounted() {
    await this.loadPaymentMethods();
    await this.loadData();
    this.allDeptOptions = this.$store.getters['preload/getDeptListOptions'] || [];
    this.doctorOptions = this.$store.getters['preload/getDoctorListOptions'] || [];
    this.regOptions = this.$store.getters['preload/getRegisterTypeListOptions'] || [];
    this.deptOptions = this.$store.getters['preload/getDeptListOptions'] || [];
    this.userInfo = JSON.parse(localStorage.getItem('userInfo')) || {};
    if (this.userInfo?.isInsurance === '1') {
      const res = await getqdNo();
      this.signNo = res.data?.signNo;
    }
  },

  methods: {
    // 加载支付方式
    async loadPaymentMethods() {
      try {
        const res = await getPatternPaymentList();
        if (res.code === 200) {
          this.dynamicPaymentMethods = res.data;
        }
      } catch (error) {
        console.error('加载支付方式失败:', error);
      }
    },

    // 获取支付方式名称
    getWayNameById(wayId) {
      const method = this.dynamicPaymentMethods.find(m => m.id === wayId);
      return method ? method.wayName : '未知';
    },

    // 检查是否可以通过该方式退款
    canRefundByWay(wayId) {
      const originalPay = this.originalPayWays.find(p => p.wayId === wayId);
      return originalPay && originalPay.amount > 0;
    },

    // 获取最大可退金额
    getMaxRefundAmount(wayId) {
      const originalPay = this.originalPayWays.find(p => p.wayId === wayId);
      return originalPay ? originalPay.amount : 0;
    },

    getAvailableRefundAmount(wayId) {
      return this.getMaxRefundAmount(wayId);
    },

    getDeptName(deptId) {
      const dept = this.allDeptOptions.find(d => d.id === deptId);
      return dept ? dept.label : '';
    },

    getDoctorName(doctorId) {
      const doctor = this.doctorOptions.find(d => d.id === doctorId);
      return doctor ? doctor.label : '';
    },

    // 重置退款表单
    resetRefundForm() {
      this.refundForm = getEmptyRefundForm();
    },

    // 打开退款弹窗
    openRefundDialog(row) {
      // 1. 校验支付明细是否有效（非空且至少有一项金额 > 0）
      let hasValidPayWay = false;
      if (Array.isArray(row.payWay) && row.payWay.length > 0) {
        hasValidPayWay = row.payWay.some(item => Number(item.amount) > 0);
      }

      if (!hasValidPayWay) {
        this.$message.warning('该订单缺少有效的支付明细数据，无法进行退款操作，请先联系管理员完善数据。');
        return; // 阻止打开弹窗
      }

      // 2. 初始化退款金额对象
      const refundAmounts = {};
      this.dynamicPaymentMethods.forEach(method => {
        refundAmounts[method.id] = 0;
      });

      // 3. 赋值并打开弹窗
      this.currentRefundRow = row;
      this.refundForm = {
        id: row.id,
        payWay: [],
        refundWays: [],
        refundAmounts: refundAmounts
      };
      this.refundDialogVisible = true;
    },    // 确认退款（多支付方式）
    async handleConfirmRefund() {
      let totalPayWayAmount = 0;
      const payWays = [];

      if (this.refundForm.refundWays && this.refundForm.refundWays.length > 0) {
        this.refundForm.refundWays.forEach(wayId => {
          const amount = this.refundForm.refundAmounts[wayId] || 0;
          if (amount > 0) {
            totalPayWayAmount += amount;
            const originalPay = this.originalPayWays.find(p => p.wayId === wayId);
            payWays.push({
              wayId: wayId,
              classId: originalPay ? originalPay.classId : 0,
              amount: amount
            });
          }
        });
      }

      if (Math.abs(totalPayWayAmount - this.refundTotalAmount) > 0.01) {
        this.$message.warning(`退款金额${totalPayWayAmount.toFixed(2)}元与应退金额${this.refundTotalAmount.toFixed(2)}元不一致`);
        return;
      }
      if (totalPayWayAmount === 0) {
        this.$message.warning('请至少选择一个退款方式并填写金额');
        return;
      }

      await withLoading(this, '退款处理中...')(async () => {
        const refundParams = { id: this.refundForm.id, payWay: payWays };
        const res = await registrationRefund(refundParams);
        if (res.code === 200) {
          this.$message.success('退款成功');
          this.refundDialogVisible = false;
          await this.loadData();
        } else {
          this.$message.error(res.message || '退款失败');
        }
      });
    },

    async handleRefundClick(row) {
      this.openRefundDialog(row);
    },

    async handleRefundMethodConfirm() {
      if (!this.selectedRefundMethod) {
        this.$message.warning('请选择退款方式');
        return;
      }
      this.showRefundMethodDialog = false;
      await this.registrationRefund(this.currentRow, this.selectedRefundMethod);
    },

    // 医保相关方法（保持不变）
    async handleYB_1191_Upload(certno, ybSel) {
      if (this.isRequesting) return false;
      this.isRequesting = true;
      try {
        const ybTemplate = buildYbRequest(this.signNo, '1191', this.userInfo.mdtrtareaAdmvs);
        ybTemplate.body = {
          ...ybTemplate.body,
          input: {
            data: {
              mdtrt_cert_type: ybSel,
              cardtype: '0',
              businesstype: '01101',
              operatorid: this.userInfo.staffId.toString(),
              operatorname: this.userInfo.staffName,
              officeid: this.userInfo.deptDepts?.find(item => item.id === this.userInfo.selDept)?.specialtyCode || '',
              officename: this.userInfo.deptDepts?.find(item => item.id === this.userInfo.selDept)?.specialtyName || '',
            }
          },
          transType: "ec.query",
          orgId: this.userInfo.clinicCode,
        };
        const res = await addYbRquestData({
          infno: '1191',
          mdtrtareaAdmvs: this.userInfo.mdtrtareaAdmvs,
          data: JSON.stringify(ybTemplate),
          patientId: this.userInfo.staffId,
          patientName: this.userInfo.staffName
        });
        if (res.code !== 200) {
          this.$message.error('交易编号:【1191】请求备份失败: ' + (res.message || '未知错误'));
          return false;
        }
        const initResult = await handleYB_1101_Upload({
          fixmedins_code: this.userInfo.clinicCode,
          infosyscode: res.data.infosyscode,
          infosyssign: res.data.infoSysSign,
          service_url: 'http://10.114.177.55:8080/eapdomain/callService'
        });
        if (!initResult.success) {
          this.$message.error('COM服务初始化失败: ' + initResult.error);
          return false;
        }
        let initData = typeof initResult.data === 'string' ? JSON.parse(initResult.data) : initResult.data;
        if (initData && initData.infcode !== 0) {
          this.$message.warning(initData.err_msg || 'ocx服务初始化异常');
          return false;
        }
        const businessParams = {
          fixmedins_code: this.userInfo.clinicCode,
          infosyscode: res.data.infosyscode,
          infosyssign: res.data.infoSysSign,
          input_data: ybTemplate.body
        };
        const businessResult = await handleYB_Business_Upload(businessParams);
        if (!businessResult.success) {
          this.$message.error('业务处理失败: ' + businessResult.error);
          return false;
        }
        let businessResponse = JSON.parse(businessResult.data);
        if (businessResponse.infcode !== 0) {
          this.$message.warning(businessResult.data.err_msg);
          return false;
        }
        await addYbResponseData({
          id: res.data.id,
          infno: '1191',
          data: JSON.stringify(businessResult)
        });
        if (certno !== businessResponse.output.cardinfo.certno) {
          this.$message.error("当前挂号信息与医保信息不一致,请核对");
          return false;
        }
        return true;
      } catch (error) {
        this.$message.error('交易编号:【1191】系统异常: ' + (error.message || '未知错误'));
        return false;
      } finally {
        this.isRequesting = false;
      }
    },

    // 退款：医保结算撤销
    async refundYbClearing(row) {
      const res = await getYbRegistrationSettleAccounts({ regId: row.id });
      if (res.code === 200) {
        await this.handleYB_2208_Upload(res.data.settlementEventId, res.data.visitEventId, res.data.psnNo);
        return true;
      } else {
        this.$message.warning(res.message + '获取挂号费用结算信息失败');
        return false;
      }
    },

    async handleYB_2208_Upload(setl_id, mdtrt_id, psn_no) {
      try {
        const ybTemplate = buildYbRequest(this.signNo, '2208');
        ybTemplate.body = {
          ...ybTemplate.body,
          input: {
            data: {
              setl_id: setl_id,
              mdtrt_id: mdtrt_id,
              psn_no: psn_no,
            }
          }
        };
        const res = await addYbRquestData({
          infno: '2208',
          mdtrtareaAdmvs: this.userInfo.mdtrtareaAdmvs,
          data: JSON.stringify(ybTemplate),
          patientId: this.userInfo.staffId,
          patientName: this.userInfo.staffName
        });
        if (res.code !== 200) {
          this.$message.error('交易编号:【2208】请求备份失败: ' + (res.message || '未知错误'));
          return false;
        }
        const headers = generateYbHeaders({
          infosyscode: res.data.infosyscode,
          signature: res.data.signature,
          clinicCode: this.userInfo.clinicCode,
          hsfNonce: res.data.hsfNonce,
          hsfTimestamp: res.data.hsfTimestamp
        });
        const ybResponse = await sendYbRequest(ybTemplate.body, headers);
        await addYbResponseData({
          id: res.data.id,
          infno: '2208',
          data: JSON.stringify(ybResponse)
        });
        if (ybResponse.infcode === -1) {
          this.$message.error('交易编号:【2208】上传失败: ' + (ybResponse.err_msg || '未知错误'));
          return false;
        }
        await this.updateYbRegistrationSettleAccounts(mdtrt_id);
        return true;
      } catch (error) {
        this.$message.error('交易编号:【2208】系统异常: ' + (error.message || '未知错误'));
        return false;
      }
    },

    // 修改挂号相关方法
    async getActiveList2() {
      const res = await getActiveList({
        regTime: this.editForm.regDate,
        type: this.editForm.timeFrame,
        deptId: this.editForm.regDepId,
      });
      this.doctorOptions = res.data.map(item => ({ id: item.doctorId, label: item.doctorName }));
    },

    async getActiveList() {
      const res = await getActiveList({
        regTime: this.editForm.regDate,
        type: this.editForm.timeFrame,
      });
      const registertype = res.data.filter(item => item.registertypeId === this.editForm.regTypeId);
      this.deptOptions = registertype
          .filter((dept, index, arr) => arr.findIndex(d => d.deptId === dept.deptId) === index)
          .map(item => ({ id: item.deptId, label: item.deptName }));
      this.editForm.regDoctorId = null;
    },

    editReservation(row) {
      this.editForm.currentDept = row.regDepId;
      this.editForm.currentDoctor = row.regDoctorId;
      this.editForm.id = row.id;
      this.editForm.regTypeId = row.regTypeId;
      this.editForm.regDate = dayjs().format('YYYY-MM-DD');
      this.editForm = { ...this.editForm, ...row };
      this.editForm.regDepId = null;
      this.editForm.regDoctorId = null;
      this.getActiveList();
      this.editModalVisible = true;
    },

    async handleCancelEditReservatione() {
      this.editForm = getEmptyEditForm();
      this.editModalVisible = false;
    },

    async editRegister() {
      await withLoading(this, '数据提交中...')(async () => {
        const res = await editRegisterList(this.editForm);
        if (res.code === 200) {
          await this.loadData();
          this.editModalVisible = false;
        } else {
          this.$message.error(res.message);
        }
      });
    },

    // 查看详情
    handleDbShowData(row) {
      this.showForm = row;
      this.showModalVisible = true;
    },

    handleCancelShow() {
      this.showForm = getEmptyShowForm();
      this.showModalVisible = false;
    },

    // 作废（已注释，保留空方法占位）
    // registrationCancellation(row) { ... }

    // 退款（旧版，保留用于医保流程）
    async registrationRefund(row, ybSel) {
      try {
        await this.$confirm(`是否确认退款挂号人 【${row.name}】的挂号订单?`, '退款确认', {
          confirmButtonText: '确认退款',
          cancelButtonText: '取消',
          type: 'warning'
        });
        if (row.payType == '5') {
          const isCertValid = await this.handleYB_1191_Upload(row.certNo, ybSel);
          if (!isCertValid) return;
          const isRefundReady = await this.refundYbClearing(row);
          if (!isRefundReady) return;
        }
        await withLoading(this, '退款处理中...')(async () => {
          const payWayList = (row.payWay || []).map(pay => ({
            wayId: pay.wayId,
            classId: pay.classId,
            amount: pay.amount
          }));
          const refundParams = { id: row.id, payWay: payWayList };
          const res = await registrationRefund(refundParams);
          if (res.code === 200) {
            this.$message.success('退款成功');
            await this.loadData();
          } else {
            this.$message.error(res.message || '退款失败');
          }
        });
      } catch (error) {
        if (error !== 'cancel') console.error('退款异常:', error);
      }
    },

    // 条件查询（复用 loadData）
    async handleConditionQuery() {
      await this.loadData();
    },

    // 加载数据
    async loadData() {
      const params = {
        pageSize: this.pageSize,
        pageNum: this.pageNum,
        condtion: this.queryConditionForm.name || '',
        startTime: this.queryConditionForm.timeFrameArr?.[0] || '',
        endTime: this.queryConditionForm.timeFrameArr?.[1] || '',
        regState: this.regState ?? null,
        type: 1
      };
      try {
        const res = await getAllReservation(params);
        if (res.code === 200) {
          this.totalSize = res.data.totalSize;
          this.tableData = res.data.content.map(item => {
            // 组装支付方式名称字符串
            let payWayNames = '';
            if (Array.isArray(item.payWay) && item.payWay.length > 0) {
              const names = item.payWay
                  .filter(pay => pay.amount > 0) // 只取金额 > 0 的支付方式
                  .map(pay => {
                    const matched = this.dynamicPaymentMethods.find(m => m.id === pay.wayId);
                    return matched ? matched.wayName : `未知(${pay.wayId})`;
                  })
                  .filter(name => name); // 过滤空字符串
              payWayNames = names.join(' / '); // 用 / 分隔
            }
            return {
              ...item,
              payType: parseInt(item.payType),
              payWayDisplay: payWayNames // 新增展示字段
            };
          });
        } else {
          this.$message.error("系统异常:请联系管理员");
        }
      } catch (error) {
        this.$message.error("系统异常:请联系管理员");
      }
    },
    // 顶部按钮
    handClick(i) {
      if (i === 0) this.loadData();
    },

    // 状态下拉筛选
    handleCommand(command) {
      this.DropDownedName =
          command === 'c' ? '未作废' :
              command === 'a' ? '已作废原单' :
                  command === 'b' ? '作废负单' : '全部';
      this.regState =
          command === 'c' ? 0 :
              command === 'a' ? 1 :
                  command === 'b' ? 2 : null;
      this.loadData();
    },

    // 分页
    handleSizeChange(val) {
      this.pageSize = val;
      this.pageNum = 1;
      this.loadData();
    },
    handleCurrentChange(val) {
      this.pageNum = val;
      this.loadData();
    },

    // 表格合计
    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      const calcFields = { 'receivableMoney': '实收金额', 'receivedMoney': '应收金额' };
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '';
          return;
        }
        if (index === 1) {
          sums[index] = '合计';
          return;
        }
        if (calcFields[column.property]) {
          const total = data.reduce((sum, item) => sum + (parseFloat(item[column.property]) || 0), 0);
          sums[index] = total.toFixed(2);
        } else {
          sums[index] = '';
        }
      });
      return sums;
    },

    // 表格映射
    safeGetMappedValue(col, row) {
      const hiddenProps = new Set([
        'usedfrquId', 'sdoseCnt', 'prdCnt', 'prdDays', 'medcWayId', 'tcmCnt',
        'selfProe', 'skintstRslt', 'remark', 'remarks', 'rxDosCnt'
      ]);
      if (hiddenProps.has(col.prop)) return '';
      const rawValue = row[col.prop];
      if (rawValue == null) return ' ';
      const mapArray = this[col.op];
      if (!col.op || !Array.isArray(mapArray)) return rawValue;
      const matched = mapArray.find(item => item.id == rawValue);
      return matched?.label || rawValue;
    },

    // 列宽计算
    getColumnWidth(label, prop, tableData) {
      if (!tableData || !tableData.length) return 120;
      const minWidth = 100;
      const padding = 30;
      const texts = [...tableData.map(item => item?.[prop] ?? ''), label];
      const maxWidth = Math.max(...texts.map(t => this.getTextWidth(String(t)) + padding));
      return Math.max(minWidth, maxWidth);
    },
    getTextWidth(text, fontSize = 14) {
      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');
      ctx.font = `${fontSize}px Microsoft YaHei`;
      return ctx.measureText(text).width;
    },
    labelHead(h, { column }) {
      column.minWidth = 12 * (column.label.length + 5);
      return h("div", { class: "table-head", style: "width:100%" }, [column.label]);
    }
  }
};
</script>
<style lang="less" scoped>
.status-dropdown .el-dropdown-menu__item {
  font-size: 12px !important;
  color: #606266 !important;
}

.status-dropdown .el-dropdown-menu__item:hover {
  color: #409EFF !important;
  background-color: #f5f7fa !important;
}
.fixed-pagination {
  position: fixed;
  bottom: 20px;
  left: 207px; /* 根据您的导航栏宽度调整 */
  right: 0;
  background: #fff;
  padding: 10px;
  box-shadow: 0 -1px 5px rgba(0, 0, 0, 0.1);
  z-index: 1000;
  display: flex;
  justify-content: center;
  align-items: center;
  width: calc(100% - 200px); /* 减去导航栏宽度 */
  margin: 0 auto;
}

.fixed-pagination .el-pagination {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 auto;
  gap: 8px;
  max-width: 100%;
}

/deep/ .el-dialog__header {
  padding: 18px;
  background-color: #007bb0;
}

/deep/ .el-dialog__title {
  font-size: 18px;
  color: #fff;
}

/deep/ .el-dialog__headerbtn .el-dialog__close {
  color: #fff;
}

.dialog {
  .showDialog {
    .tabs {
      /deep/ .el-select > .el-input {
        width: 172px;
      }

      /deep/ .el-date-editor.el-input, .el-date-editor.el-input__inner {
        width: 172px;
      }

      /deep/ .el-form-item__content {
        display: flex;

        span {
          font-size: 12px;
        }
      }

      .oneLine {
        width: 524px;
        // background-color: indianred;
      }
    }

    /deep/ .el-dialog__title {
      font-size: 15px;
    }

    /deep/ .el-table {
      font-size: 15px;
    }
  }
}


// content
.MedicenCata {
  height: 100%;
  width: 100%;
  // header
  .header {
    display: flex;
    flex-direction: row;
    align-items: center;
    height: 40px;
    background-color: #efefef;
    padding: 4px;

    // justify-content: space-evenly;
    // icon
    .header-icon {
      display: flex;
      align-items: center;
    }

    .feetbtn {
      display: flex;
      justify-content: center;
      margin-left: 12px;
    }
  }

  // main
  .main {
    width: 100%;
    display: flex;
    justify-content: space-between;
    // height: 473px; /* 设置父容器的高度 */
    // overflow-y: auto; /* 当内容超出容器高度时显示垂直滚动条 */
    // left

    // right
    .main-right {
      flex: 1;
      width: 100%;
      height: 100%;
      // alert
      .addmessagesBox {
        .tabs {
          /deep/ .el-select > .el-input {
            width: 172px;
          }

          /deep/ .el-date-editor.el-input, .el-date-editor.el-input__inner {
            width: 172px;
          }

          /deep/ .el-form-item__content {
            display: flex;

            span {
              font-size: 12px;
            }
          }

          .oneLine {
            width: 524px;
            // background-color: indianred;
          }
        }

        /deep/ .el-dialog__title {
          font-size: 12px;
        }

        /deep/ .el-table {
          font-size: 12px;
        }

      }

      // icon
      .main-icon {
        display: flex;
        align-items: center;
        padding: 12px;
        line-height: 40px;

        .main-icon-a {
          // width: 240px;
          // background-color: #00557f;
        }

        .main-icon-b {
          margin-left: 20px;

          /deep/ .el-dropdown {
            font-size: 12px;
            cursor: pointer;
          }

          /deep/ .el-dropdown:hover {
            font-weight: bold;
            color: #66b1ff;
          }

          /deep/ .el-icon--right {
            // background-color: #66b1ff;
          }

          /deep/ .el-popper[x-placement^=bottom] {
            margin-top: 0;
          }
        }

        // c
        .main-icon-c {
          display: flex;
          margin-left: 28px;

          /deep/ [data-v-2bacc09b] .el-color-picker__icon, .el-input[data-v-2bacc09b], .el-textarea[data-v-2bacc09b] {
            width: 80%;
          }
        }
      }

      // table
      /deep/ .el-table .cell {
        font-size: 12px;
        text-align: center;
      }

      /deep/ .el-table td.el-table__cell div :first-child {
        text-align: center;
      }

      /deep/ .el-table td.el-table__cell div {
        text-align: center;
        overflow: hidden;
        white-space: normal;
        word-break: break-all;
      }

      .table {

      }
    }
  }

  // addModel
  .addModel {
    margin-left: 12px;

    /deep/ .el-dialog__header {
      padding: 12px;
      line-height: 28px;
      background-color: #007bb0;
    }

    /deep/ .el-dialog__title {
      color: #fff;
      font-size: 12px;
    }

    /deep/ .el-dialog__headerbtn .el-dialog__close {
      color: #fff;
    }

    /deep/ .el-dialog__headerbtn .el-dialog__close:hover {
      background-color: brown;
    }

    /deep/ .el-form-item__label {
      font-size: 12px;
    }
  }

  .editModel {
    /deep/ .el-dialog__header {
      padding: 12px;
      line-height: 28px;
      background-color: #007bb0;
    }

    /deep/ .el-dialog__title {
      color: #fff;
      font-size: 12px;
    }

    /deep/ .el-dialog__headerbtn .el-dialog__close {
      color: #fff;
    }

    /deep/ .el-dialog__headerbtn .el-dialog__close:hover {
      background-color: brown;
    }

    /deep/ .el-form-item__label {
      font-size: 12px;
    }
  }

  // feet
  .feet {
    padding: 12px;

  }

}
</style>